// AllUser.js
import React, { Component } from "react";
import axios from "axios";

const EndPoint = process.env.REACT_APP_API_ENDPOINT;

class AllUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      loading: true,
      error: null,
    };
  }

  async componentDidMount() {
    try {
      const res = await axios.get(`${EndPoint}/user/sumuser`, {
        withCredentials: true,
      });

      this.setState({
        users: res.data || [],
        loading: false,
      });

    } catch (error) {
      console.error("Error fetching user summary:", error);
      this.setState({ error: "Failed to load users", loading: false });
    }
  }

  handleResendVerification = async (email) => {
        try {
            const res = await axios.post(
            `${EndPoint}/user/resend-verification`,
            { email },
            { withCredentials: true }
            );

            alert("Verification email sent!");
        } catch (error) {
            console.error("Error sending verification email:", error);
            alert("Failed to send verification email.");
        }
    };


  render() {
    const { users, loading, error } = this.state;

    if (loading) return <div className="p-4">Loading...</div>;
    if (error) return <div className="p-4 text-red-500">{error}</div>;

    return (
      <div className="p-4 overflow-x-auto">
        <h2 className="text-xl font-bold mb-4">All Users</h2>

        <table className="min-w-full border border-gray-300 bg-white text-sm">
          <thead className="bg-gray-100">
            <tr>
              <th className="border p-2">id</th>
              <th className="border p-2">firstName</th>
              <th className="border p-2">lastName</th>
              <th className="border p-2">email</th>
              <th className="border p-2">subscriptions</th>
              <th className="border p-2">Email Verified</th>
            </tr>
          </thead>

          <tbody>
            {users.length > 0 ? (
              users.map((entry) => (
                <tr key={entry.id}>
                  <td className="border p-2">{entry.id}</td>
                  <td className="border p-2">{entry.firstName}</td>
                  <td className="border p-2">{entry.lastName}</td>
                  <td className="border p-2">{entry.email}</td>


                  <td className="border p-2">
                    {Array.isArray(entry.stripe)
                      ? entry.stripe.subscriptionStatus.join(", ")
                      : entry.stripe.subscriptionStatus || "—"}
                  </td>

                  <td className="border p-2">
                      <td>
                        {entry.isEmailVerified ? (
                            <div className="px-2 py-1 rounded text-white text-center bg-sky-800">
                            Yes
                            </div>
                        ) : (
                            <button
                            onClick={() => this.handleResendVerification(entry.email)}
                            className="px-2 py-1 rounded text-white bg-red-600 hover:bg-red-700 text-center"
                            >
                            Resend Email
                            </button>
                        )}
                        </td>

                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="10" className="text-center p-4">
                  No users found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    );
  }
}

export default AllUser;
